import React from 'react';
import PropTypes from 'prop-types';

const UserInfo = ({
  handleSubmit,
  onChange,
  firstName,
  lastName,
  emailLogin,
  phoneNumber,
}) => {
  return (
    <div className="add-user-container">
      <div className="add-user-form">
        <form onSubmit={handleSubmit}>
          <div className="add-user-form--wrapper">
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <label htmlFor="firstName">
                    First Name <span className="field-required">*</span>
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    className="form-control"
                    placeholder="First Name"
                    value={firstName}
                    type="text"
                    onChange={e => onChange(e, 'firstName')}
                  />
                </div>
              </div>
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <label htmlFor="lastName">
                    Last Name <span className="field-required">*</span>
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    className="form-control"
                    placeholder="Last Name"
                    value={lastName}
                    type="text"
                    onChange={e => onChange(e, 'lastName')}
                  />
                </div>
              </div>
            </div>
            <div className="add-user-form--row">
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <label htmlFor="emailLogin">
                    Email <span className="field-required">*</span>
                  </label>
                  <input
                    id="emailLogin"
                    name="emailLogin"
                    className="form-control"
                    placeholder="Email"
                    value={emailLogin}
                    type="email"
                    onChange={e => onChange(e, 'emailLogin')}
                  />
                </div>
              </div>
              <div className="add-user-form--col">
                <div className="add-user-form--group">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <input
                    id="phoneNumber"
                    name="phoneNumber"
                    className="form-control"
                    placeholder="Phone Number"
                    value={phoneNumber}
                    type="text"
                    onChange={e => onChange(e, 'phoneNumber')}
                  />
                </div>
              </div>
            </div>
          </div>
          <button type="submit" className="sr-only">
            &nbsp;
          </button>
        </form>
      </div>
    </div>
  );
};

UserInfo.propTypes = {
  handleSubmit: PropTypes.func,
  onChange: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  emailLogin: PropTypes.string,
  phoneNumber: PropTypes.string,
};

UserInfo.defaultProps = {
  firstName: '',
  lastName: '',
  emailLogin: '',
  phoneNumber: '',
};

export default UserInfo;
